import React, { useState, useEffect } from "react";

export default function FontLoader({ children }) {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    const loadFonts = async () => {
      try {
        // Wait for all font variations to load
        await Promise.all([
          document.fonts.load('300 1em "SF Pro Display"'),
          document.fonts.load('400 1em "SF Pro Display"'),
          document.fonts.load('500 1em "SF Pro Display"'),
          document.fonts.load('600 1em "SF Pro Display"'),
          document.fonts.load('300 1em "Loretta"'),
        ]);

        // Set fonts as loaded
        setFontsLoaded(true);
      } catch (error) {
        console.error("Font loading error:", error);
        // Fallback to showing content even if fonts fail
        setFontsLoaded(true);
      }
    };

    loadFonts();
  }, []);

  // Render children only when fonts are loaded
  if (!fontsLoaded) {
    return null;
  }

  return children;
}